import * as React from "react"
import { AfterPage } from "types/afterjs"
import { SearchResult } from "types/search"
import { Card, Typography, Seo } from "components"
import { Link } from "react-router-dom"
import { toPersianDigits } from "utils"
import doSearch from "./action"

interface SearchPage {
	data: SearchResult
}

interface MatchProps {
	q: string
}

const SearchPage: AfterPage<SearchPage, MatchProps> = ({ data, error }) => {
	if (error) {
		return <p>خطا در دریافت اطلاعات {error.message}</p>
	}

	return (
		<>
			<Seo
				title="جستجو"
				path="/search"
				description="جستجو محصولات و مقالات مربوط به آنتی ویروس"
				robots="noindex"
			/>
			<Card title="نتیجه جستجو">
				<Typography gutterBottom variant="body2" color="muted">
					تعداد نتایج پیدا شده: {toPersianDigits(data.count)}
				</Typography>
				<ul className="list-group list-group-flush">
					{data.result.map(({ id, title, url }) => (
						<li key={id} className="list-group-item">
							<Link to={url}>{title}</Link>
						</li>
					))}
				</ul>
			</Card>
		</>
	)
}

SearchPage.getInitialProps = async ({ match }) => {
	const searchTerm = match.params.q
	try {
		const { data } = await doSearch(searchTerm)
		return { data }
	} catch (error) {
		return { error }
	}
}

export default SearchPage
